import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { trackingService } from '@/api/services/trackingService'

export function useActiveUsers(p?: Parameters<typeof trackingService.activeUsers>[0]) {
  return useQuery({ queryKey: ['tracking', 'active', p], queryFn: () => trackingService.activeUsers(p), staleTime: 30_000 })
}
export function useDeletedUsers(p?: Parameters<typeof trackingService.deletedUsers>[0]) {
  return useQuery({ queryKey: ['tracking', 'deleted', p], queryFn: () => trackingService.deletedUsers(p), staleTime: 30_000 })
}
export function useDeleteUserTracking() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (id: number) => trackingService.deleteUser(id), onSuccess: () => qc.invalidateQueries({ queryKey: ['tracking'] }) })
}
export function useRestoreUser() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (id: number) => trackingService.restoreUser(id), onSuccess: () => qc.invalidateQueries({ queryKey: ['tracking'] }) })
}
